module.exports = __webpack_public_path__ + "img/TZS09529.872b0c42.jpeg";